// ============================================================
// BLINKBLIS — CAPA DE PROTECCION DE CONTENIDO
// ------------------------------------------------------------
// HONESTIDAD TECNICA, LEELO ANTES DE CONFIAR EN ESTO:
//
// Nada de este archivo impide que alguien tecnico vea el codigo.
// Ctrl+U, las DevTools, "curl", la cache de Google y el codigo
// fuente compilado siguen disponibles. Todo frontend es publico
// por definicion: el navegador del usuario TIENE que poder leerlo
// para poder pintarlo.
//
// Para que sirve entonces:
//   - Frena la copia casual de contenido editorial (el 95% de los
//     que te copian no abren DevTools, hacen clic derecho).
//   - Evita que arrastren tus imagenes y tu logo.
//   - Si copian texto largo, se llevan la atribucion pegada.
//
// Lo que SI protege el negocio de verdad no esta aqui, esta en:
//   - offers/config.ts   -> el link de afiliado vive en un solo lugar
//   - pages/Go.tsx       -> la salida es una ruta propia, no la URL cruda
//   - components/Newsletter.tsx -> honeypot anti-bots
//   - rel="nofollow sponsored noopener noreferrer" en todo enlace pagado
// ============================================================

export const SECURITY = {
  // Clic derecho bloqueado en el contenido.
  // Se respeta SIEMPRE en inputs y textareas: el usuario tiene que
  // poder pegar su correo en el newsletter. Romper eso cuesta
  // suscriptores reales para no ganar nada.
  blockContextMenu: true,

  // Impide arrastrar imagenes fuera del sitio (logo, graficos).
  blockImageDrag: true,

  // Atajos de DevTools (F12, Ctrl+Shift+I/J/C, Ctrl+U, Ctrl+S).
  // Es disuasion cosmetica: no detiene a nadie con intencion real.
  // Ponlo en false si prefieres no molestar a usuarios avanzados.
  blockDevtoolsShortcuts: true,

  // Al copiar un bloque largo, se adjunta la fuente automaticamente.
  // Esto si tiene valor de marketing: tu contenido circula citado.
  copyAttribution: true,
  copyAttributionMinChars: 120,

  // Politica de referrer: no filtra la URL completa (con utm y subIds)
  // a sitios de terceros. Protege tu inteligencia de campana.
  strictReferrerPolicy: true,
} as const
